import { NgModule } from '@angular/core'
import { provideConfig, provideDefaultConfig } from '@spartacus/core'
import { defaultB2bOccConfig } from '@spartacus/setup'
import { environment } from '../../environments/environment'
import ebFontawesomeIconConfig from '../components/icons/config/eb-fontawesome-icon.config'
import { ebIconConfig } from '../components/icons/config/eb-icon.config'
import { EbI18nConfig } from '../features/i18n/config/eb-i18n-config'
import { ebBackendEndpointsConfig } from './eb-endpoint.config'
import { ebI18nChunkConfig } from './eb-i18n-chunks.config'

const occBaseUrl = environment.occBaseUrl || getMetatagContent('occ-backend-base-url')

@NgModule({
  providers: [
    provideDefaultConfig(defaultB2bOccConfig),
    provideDefaultConfig(ebFontawesomeIconConfig),
    provideDefaultConfig(ebIconConfig),
    provideConfig({
      i18n: {
        backend: {
          loadPath: `${occBaseUrl}/i18n/ebB2B-DEU/assets/chunks/{{ns}}?lang={{lng}}` // do not change as this is the fallback value
        },
        fallbackLang: false, // do not change or it will break browser language detection
        ...ebI18nChunkConfig,
        skipDefaultTranslations: true
      }
    } as EbI18nConfig),
    provideConfig({
      backend: {
        occ: {
          prefix: '/occ/v2/',
          baseUrl: occBaseUrl,
          endpoints: ebBackendEndpointsConfig,
          useWithCredentials: true
        }
      },
      context: {
        currency: ['EUR' , 'USD'],
        baseSite: ['ebB2B-DEU'],
        urlParameters: ['country', 'language']
      },
      authentication: {
        client_id: 'eb_b2b_SPA',
        client_secret: 'H5Ak415NbD4ld2xt'
      },
      smartEdit: {
        storefrontPreviewRoute: 'cx-preview',
        allowOrigin:
          'localhost:4200, ' +
          'localhost:9002, ' +
          'octavia.sybit.de:443, ' +
          'backoffice.ce704ki4x6-eagleburg1-d1-public.model-t.cc.commerce.ondemand.com:443, ' +
          'backoffice.ce704ki4x6-eagleburg1-d2-public.model-t.cc.commerce.ondemand.com:443, ' +
          'backoffice.ce704ki4x6-eagleburg1-s1-public.model-t.cc.commerce.ondemand.com:443, ' +
          'backoffice.ce704ki4x6-eagleburg1-p1-public.model-t.cc.commerce.ondemand.com:443, ' +
          'backend.shop.myeagleburgmann.com:443, ' +
          'backend-qa.myeagleburgmann.com:443'

      },
      routing: {
        routes: {
          product: {
            paths: [':fullProductPath/p/:productCode'],
            paramsMapping: { productCode: 'code', fullProductPath: 'fullProductPath' }
          },
          ebParentProduct: {
            paths: ['p/:productCode'],
            paramsMapping: { productCode: 'code'}
          },
          variant: {
            paths: [':fullProductPath/v/:productCode'],
            paramsMapping: { productCode: 'code', fullProductPath: 'fullProductPath' }
          },
          orderDetails: {
            paths: ['my-account/order/:orderCode'],
            paramsMapping: { orderId: 'code' }
          },
          rfp: {
            paths: ['rfp/:productCode/:productName'],
            paramsMapping: { productCode: 'code', productName: 'name' }
          }
        }
      }
    })
  ]
})
export class EbConfigurationModule {}

// helper function to read occBaseUrl from index.html meta tag
// https://github.com/SAP/spartacus/issues/5886
function getMetatagContent(metaName: string) {
  if (typeof document !== 'undefined') {
    const metaTags = Array.from(document.getElementsByTagName('meta'))
    const metaTag = metaTags.find(m => m.getAttribute('name') === metaName)
    if (metaTag) {
      return metaTag.getAttribute('content')
    }
  }
  return undefined
}
